export const BUILD_VERSION = '1784642387';
